
import { UIError } from '~/lib/api/types/errors/Errors';
let initialize_started = false;

let promise;

/**
 * Initialize the YouTube API. Can be run concurrently in single event loop. After
 * this function resolves then window.YT is available globally.
 */
async function initialize_yt_api() {
  if (initialize_started || window.YT) {
    return promise;
  }
  initialize_started = true;

  promise = new Promise((resolve, reject) => {
    let resolved = undefined;
    window.onYouTubeIframeAPIReady = () => {
      if(resolved === false) {
        return;
      }
      resolved = true;
      resolve();
    };

    setTimeout(() => {
      if (resolved === undefined) {
        resolved = false;
        reject(new UIError('Nie można załadować filmu youtube (timeout)'));
      }
    }, 30000);
  });

  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';

  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  console.log('Waiting for YouTube API to load...');
  await promise;
  console.log('YouTube API loaded.');
}

// Based on https://stackoverflow.com/a/54921282/1637178 | CC BY-SA 4.0 | by Bill
// Rewritten to Vue.js by Copilot.
// Modified by Jan Święcki.
export default {
  name: 'YouTubeVideo',
  props: {
    id: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
  },
  data() {
    return {
      videoClass: 'video',
      destroying: false,
      randomId: Math.random().toString(36).substring(2)
    };
  },
  async mounted() {
    await initialize_yt_api();
    this.loadVideo();
  },
  beforeDestroy() {
    this.destroying = true;
    if (this.player) {
      console.log(`Destroying player ${this.playerId}`)
      this.player.destroy();
    }
  },
  methods: {
    loadVideo() {
      if(this.destroying) {
        return;
      }

      const { id } = this.$props;

      // the Player object is created uniquely based on the id in props
      // https://developers.google.com/youtube/iframe_api_reference
      this.player = new window.YT.Player(this.playerId, {
        videoId: id,
        width: this.width,
        height: this.height,
        events: {
          onReady: event => this.$emit('ready', event),
          onStateChange: event => this.$emit('stateChange', event)
        }
      });
    },
  },
  computed: {
    playerId() {
      return `youtube-player-${this.id}-${this.randomId}`;
    }
  }
};
